/* @flow */
import {
  GET_SCENES,
  SET_VIEW_SCENE,
} from '../configs/constants'

export function getScenes() {
  return { type: GET_SCENES }
}

export function setViewScene(scenes) {
  return { type: SET_VIEW_SCENE, scenes }
}



// WEBPACK FOOTER //
// ./src/actions/scene.js